import { render } from "./CloseLoanBlockInfo.vue?vue&type=template&id=8f631dd0"
import script from "./CloseLoanBlockInfo.vue?vue&type=script&lang=js"
export * from "./CloseLoanBlockInfo.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__